import React from "react";
import { StyleSheet, View, ViewProps } from "react-native";
import { kColors } from "src/kColors";

export const PdCenter: React.FC<ViewProps> = ({ style, ...rest }) => (
  <View style={[styles.pdCenter, style]} {...rest} />
);

export const PdRow: React.FC<ViewProps> = ({ style, ...rest }) => <View style={[styles.pdRow, style]} {...rest} />;

export const PdDivider: React.FC<ViewProps & { isVertical?: boolean }> = ({ style, isVertical, ...rest }) => (
  <View style={[isVertical ? styles.pdDividerVertical : styles.pdDividerHorizontal, style]} {...rest} />
);

const styles = StyleSheet.create({
  pdCenter: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  pdDividerHorizontal: {
    backgroundColor: kColors.grayPink,
    height: StyleSheet.hairlineWidth,
  },
  pdDividerVertical: {
    backgroundColor: kColors.grayPink,
    height: "100%",
    width: StyleSheet.hairlineWidth,
  },
  pdRow: {
    alignItems: "center",
    flexDirection: "row",
  },
});
